module.exports = __webpack_public_path__ + "static/media/sponsor-logo.128aa0ea.png";